<template>
	<div>
		<div v-show="allData.length==0">
					
					<a-result  title="暂无数据">
					   
					  </a-result>
				</div>
		<div   class="downCard" v-for="(item,index) in allData">
				<p style="margin: 0;font-size: 1rem;">
					{{item.documentName}}
				</p>
				<p style="flex: 1;margin: 0;font-size: 1rem;color: lightgray;">
					（{{item.createTime.slice(0,10)}}）
				</p>
				<div v-show="item.downloadPath!==''" class="downHover" style="cursor: pointer;"  @click="downloadFile(item)">
					<a-icon  type="download" />
				</div>
				
		</div>
		
		<div style="position: absolute;bottom: 10px;right: 700px;padding-bottom: 150px;">
			<a-pagination :defaultPageSize="5" :pageSizeOptions="['5', '10', '20', '40']" v-model="queryPage.current"
				@showSizeChange="changeSize" @change="changeCurrent"
				style="display: block !important;margin-left: 15.625rem" :total="total" size="small"  show-size-changer
				show-quick-jumper />
		</div>
	</div>
</template>

<script>
	import {SelDocument,SelDocumentType} from '@/api/index.js'
	export default{
		props:['ids'],
		data(){
			return{
				queryPage: {
					current: 1,
					pageSize: 5
				},
				total:10,
				orgId:1,
				allData:[]
			}
		},
		created(){
			if(this.$route.path=='/downLoad'){
				this.orgId = 2
			}
			if(this.$route.path=='/downLoad2'){
				this.orgId = 26
			}
			this.getDatas()
		},
		watch: { //动态监听路由变化 -以便动态更改导航背景色事件效果等
			'$route'(to, from) {
				// 对路由变化作出响应...
				let current1 = this.$route.path
				console.log(this.$route.path)
				if(this.$route.path=='/downLoad'){
					this.orgId = 2
					this.getDatas()
				}
				if(this.$route.path=='/downLoad2'){
					this.orgId = 26
					this.getDatas()
				}
				// console.log(current1)
				// this.currentUrl = current1
				// if (current1 == '/') {
				// 	this.states = 'index'
				// } else {
				// 	this.states = ''
				// }
			}
		},
		methods:{
			 async getDatas(){
				 let data = {LabId:this.orgId,type:this.ids,page:this.queryPage.current,row:this.queryPage.pageSize,name:window.localStorage.getItem('searchValues')}
				 if(this.ids=='空'){
					  data = {LabId:this.orgId,type:undefined,page:this.queryPage.current,row:this.queryPage.pageSize,name:window.localStorage.getItem('searchValues')}
				 }
				const res = await SelDocument(data)
				this.total = res.data.totalCount
				this.allData = res.data.data
			},
			changeSize(current, size) {
				console.log(current, size)
				this.queryPage.pageSize = size
				this.queryPage.current = current
				this.getDatas()
			},
			changeCurrent(val) {
				this.queryPage.current = val
				this.getDatas()
			},
			downloadFile(val){
				window.open(val.downloadPath,'_blank')
			
				// window.location.href =  val.downloadPath
				
				// var test = window.open()
				// setTimeout(function() {
				// 	console.log(val)
				//   test.location = val.downloadPath
				// }, 1)
				// let url = val.downloadPath
				// console.log(val.downloadPath)
				// let fileName = 'ddd.txt'
				// let mime = 'txt'
				//  axios.get(url, { responseType: 'blob' })
				//     .then(res => {
				//       let blob = new Blob([res.data], { type: mime }) 
				//       // 注: mime类型必须整正确, 否则下载的文件会损坏
				//         if (window.navigator && window.navigator.msSaveOrOpenBlob) { // 兼容IE
				//           window.navigator.msSaveOrOpenBlob(blob, element.original_name);
				//         } else {
				//           let downloadElement = document.createElement('a');
				//           downloadElement.href = window.URL.createObjectURL(blob); // 创建一个DOMString
				//           downloadElement.download = fileName;
				//           downloadElement.click();
				//           window.URL.revokeObjectURL(blob); // 释放 DOMString  ,解除内存占用
				//         }
				//     })
				//     .catch(error => {
				//       console.error(error)
				//     })
				// console.log(val)
			},
		}
	}
</script>

<style>
	.downCard {
		display: flex;
		align-items: center;
		width: 100%;
		height: 5.75rem;
		/* margin: 0 3.55rem; */
		border-bottom: 1px solid rgba(0, 0, 0, 0.05);
		transition-duration: 0.25s;
	}
	.downCard:hover{
		color: #1890FF;
		transform: scale(1.01);
		
	}
</style>
